import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import { Button, Text, Flex, Box, Stack } from "@mantine/core";
import axios from "axios";

import submitTroubleTicket from "@util/submitTroubleTicket";
import hogCreateErrorCodes from "@lib/hog-create-error-codes";

export default function HogMembershipCreateError({ serverMessage = null, errorCode = null, ticketData = {} }) {
  const errorCodeData = hogCreateErrorCodes[errorCode];

  useEffect(() => {
    if (errorCodeData?.auto_submit_ticket) {
      submitTicket();
    }
  }, [JSON.stringify(errorCodeData)]);

  function submitTicket() {
    const requestedTicketVarData = errorCodeData.ticket_vars.reduce((acc, varName) => {
      if (ticketData[varName]) {
        acc[varName] = ticketData[varName];
      }
      return acc;
    }, {});
    const req = {
      ...requestedTicketVarData,
      campaign_effort_id: ticketData.campaign_effort_id,
      issue_description: serverMessage || "An error occurred while creating HOG membership",
    };

    submitTroubleTicket(req).then(() => {
      // toast.success("Ticket submitted");
    }).catch((err) => {
      // toast.error(err);
    });
  }

  return (
    <div>
      <Stack gap="md">
        {errorCodeData?.preamble_text && <Text c="red" size="lg" align="center" fw={600}>{errorCodeData.preamble_text}</Text>}
        {serverMessage && <Text align="center" size="lg" c="white">{serverMessage}</Text>}
        {errorCodeData?.resolution_text && <Text align="center" size="lg" c="white">{errorCodeData.resolution_text}</Text>}
        {!errorCodeData && !serverMessage && <Text fw={600} align="center" size="lg" c="white">An error occurred while creating your HOG membership. Please try again later.</Text>}
        {/* <Button size="md">Request Assistance</Button> */}
      </Stack>
    </div>
  )
}

const StyledLogo = styled.img`
  max-width: 300px;
  margin: 0 auto 1em auto;
  display: block;
`;
